import { ExclamationIcon } from '@heroicons/react/solid';
import { useState, useEffect } from 'react'
import { collection, getFirestore, getDocs, deleteDoc, doc} from "firebase/firestore";
import { getDatabase, ref, set } from 'firebase/database';
import app from "../../api/firebaseConf"
import {PencilAltIcon, PencilIcon} from "@heroicons/react/solid"
import BtnModalConfig from "./ButtonForm"

export default function Alerts (){

    const [alert,setAlert] = useState([])
    const [refresh, setRefresh] = useState(true)
    const [modal, setModal] = useState(false);

    const db = getFirestore(app)
    const realtimedb = getDatabase(app)

    const handleClose = () => {
        setModal(false)   
    }

    useEffect(()=>{
        const obtenerDatos =  async()=>{
            const datos = await getDocs(collection(db,'alertas'));
            const alertas = []

            datos.forEach(doc=>{
                alertas.push({...doc.data(),id:doc.id})
            })

            setAlert(alertas)
        }

        obtenerDatos()
        console.log(alert)

    },[refresh])

    const onDelete = async(id) => {
        if (window.confirm("Estas seguro de eliminar esta alerta? ")){
            console.log('delete: '+id)
            await deleteDoc(doc(db, 'alertas',id))
            setRefresh(!refresh)
        }
    }

    const onButtonEmergency = async()=>{
        set(ref(realtimedb, 'panicbutton/'),'yes')
    }

    return (
        <div className='pt-14 sm:pt-0' >

            <h1 className='text-3xl font-press-start font-bold mb-4 sm:mb-8 px-1 text-center'>ALARMAS Y NOTIFICACIONES</h1>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-4'>
                <div className="flex items-center">
                <button onClick={()=>onButtonEmergency()} className="flex grow items-center justify-center bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-b-4 border-red-700 hover:border-red-500 rounded">
                    <b className='text-lg uppercase py-4'>EMERGENCIA</b> <ExclamationIcon className='h-6 fill-white-600'/>
                </button>
                <div className="rounded-lg bg-white hover:bg-slate-200 shadow-md p-2 ml-4 cursor-pointer" onClick={()=>setModal(true)} >
                    <PencilIcon className="flex-none h-5 w-5 hover fill-blue-500 hover:fill-blue-700 cursor-pointer"/>
                </div>
                </div>
            </div>
            {<BtnModalConfig open = {modal} close = {handleClose}/>}

            <div className='py-4'>
                {
                alert.map((info)=>{
                    if ( info.tipo === 'info' ){
                       return (<div key = {info.id} id={info.id} className="flex p-4 mb-4 bg-blue-100 rounded-lg dark:bg-blue-200" role="alert">
                       <svg aria-hidden="true" className="flex-shrink-0 w-5 h-5 text-blue-700 dark:text-blue-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                       <span className="sr-only">Info</span>
                       <div className="ml-3 text-sm font-medium text-blue-700 dark:text-blue-800">
                        {info.mensaje}
                       </div>
                         <button type="button" onClick={()=>onDelete(info.id)} className="ml-auto -mx-1.5 -my-1.5 bg-blue-100 text-blue-500 rounded-lg focus:ring-2 focus:ring-blue-400 p-1.5 hover:bg-blue-200 inline-flex h-8 w-8 dark:bg-blue-200 dark:text-blue-600 dark:hover:bg-blue-300" data-dismiss-target="#alert-1" aria-label="Close">
                           <span className="sr-only">Close</span>
                           <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                       </button>
                     </div>)
                    }else if ( info.tipo === 'warn' ){
                        return (
                        <div key = {info.id} id={info.id} className="flex p-4 mb-4 bg-yellow-100 rounded-lg dark:bg-yellow-200" role="alert">
                        <svg aria-hidden="true" className="flex-shrink-0 w-5 h-5 text-yellow-700 dark:text-yellow-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                        <span className="sr-only">Info</span>
                        <div className="ml-3 text-sm font-medium text-yellow-700 dark:text-yellow-800">
                        {info.mensaje}                        
                        </div>
                        <button type="button" onClick={()=>onDelete(info.id)} className="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300" data-dismiss-target="#alert-4" aria-label="Close">
                            <span className="sr-only">Close</span>
                            <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </button>
                        </div>)
                    }else if (info.tipo === 'critical'){
                        return (
                        <div key = {info.id} id={info.id} className="flex p-4 mb-4 bg-red-100 rounded-lg dark:bg-red-200" role="alert">
                        <svg aria-hidden="true" className="flex-shrink-0 w-5 h-5 text-red-700 dark:text-red-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                        <span className="sr-only">Info</span>
                        <div className="ml-3 text-sm font-medium text-red-700 dark:text-red-800">
                        {info.mensaje}                        
                        </div>
                        <button type="button" onClick={()=>onDelete(info.id)} className="ml-auto -mx-1.5 -my-1.5 bg-red-100 text-red-500 rounded-lg focus:ring-2 focus:ring-red-400 p-1.5 hover:bg-red-200 inline-flex h-8 w-8 dark:bg-red-200 dark:text-red-600 dark:hover:bg-red-300" data-dismiss-target="#alert-2" aria-label="Close">
                            <span className="sr-only">Close</span>
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </button>
                        </div>)
                    }

                        // return <div key={info.id} id="alert-1" className={`flex p-4 mb-4 bg-${color}-100 rounded-lg dark:bg-${color}-200" role="alert`}>
                        // <svg aria-hidden="true" className={`flex-shrink-0 w-5 h-5 text-${color}-700 dark:text-${color}-800`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                        // <span className="sr-only">Info</span>
                        // <div className={`ml-3 text-sm font-medium text-${color}-700 dark:text-${color}-800`}>
                        //     {info.mensaje}  
                        // </div>
                        //     <button type="button" onClick={()=>onDelete(info.id)} className={`ml-auto -mx-1.5 -my-1.5 bg-${color}-100 text-${color}-500 rounded-lg focus:ring-2 focus:ring-${color}-400 p-1.5 hover:bg-${color}-200 inline-flex h-8 w-8 dark:bg-${color}-200 dark:text-${color}-600 dark:hover:bg-${color}-300`} data-dismiss-target="#alert-1" aria-label="Close">
                        //     <span className="sr-only">Close</span>
                        //     <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        //     </button>
                        // </div>
                    })
                }

            </div>

        </div>
    )
}